// extracted by mini-css-extract-plugin
export default {"invalid":"RolEdit_invalid__Kl3yQ","spinnerContainer":"RolEdit_spinnerContainer__5AbzO"};